import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FormInput } from '../components/FormInput';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SystemLoading, checkLoading } from '../store/loadingStore';
import { useForm } from 'react-hook-form';

import { Button } from 'primereact/button';
import { Steps } from 'primereact/steps';
import { Tooltip } from 'primereact/tooltip';

import bgCtBottom from "../assets/images/layout/bg-ct-bottom.svg"
import LoginCommonOutline from './login/LoginCommonOutline';
import { F0010103Before, F0010101Before, F0010102Before, registerAcct, registerMainSubAcct, registerTaxIdNum } from '../utility/service/register-service';
import { checkDpSuccess, handleSessionClear, loginClientId } from '../utility/service/tool-service';
import { MessageContext, handleSuccessMessage } from '../store/messageStore';
import RegisterStep3 from './RegisterStep3';
import { AlertService, AlertType } from '../utility/service/alert-service';

import CompanyRoleSelector from "../components/layout/CompanyRoleSelector"
import { addFormValidator } from '../utility/validate/formValidator';
import PDFViewer from './login/PDFViewer';
import { initDataProp } from '../utility/service/api-service';
import PrimeDialog from '../components/dialog/PrimeDialog';
import { getSupportedLanguage } from '../utility/languageUtils';


const Register = () => {

  const { t, i18n } = useTranslation();
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗 
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isExistCompany, setIsExistCompany] = useState(false);
  const { issuer } = useParams();
  const [confirmLoad,setConfirmLoad] = useState(false);
  const [formRule, setFormRule] = useState([]); //表單驗證
  const [hasLoad, setHasLoad] = useState(false); // 隱私權條款載入

  const {
    register,
    handleSubmit,
    resetField,
    reset,
    watch,
    getValues,
    setValue,
    clearErrors,
    control,
    formState: { errors,isValid }
  } = useForm({
    defaultValues: {
      userAcct: '',
      userPcode: ''
    },
    //錯誤驗證時機
    mode: 'all'
  });

  //表單驗證
  const registerOptions = {
    userAcct: { required: t('user_name_required') },
    userPcode: {
      required: t('password_required'),
      pattern: {
        value: /^[A-Z0-9]{6,12}$/i,
        message: t('validation.passwordPattern')
      }
    },
    userPcodeSecond: {
      required: t('password_required'),
      validate: (val) => {
        if (watch('userPcode') !== val) return t('validation.confirm_password')
      },
      pattern: {
        value: /^[A-Z0-9]{6,12}$/i,
        message: t('validation.passwordPattern')
      }
    },
    taxIdNum: {
      required: t('validation.required'),
      pattern: {
        value: /^[0-9]*$/,
        message: t('validation.numberLen', { len: 8 })
      }
    }

  }

  useEffect(()=>{
    if(issuer==='GOOGLE'){
      setActiveIndex(1);
    }
  },[issuer])

  useEffect(() => {
    i18n.changeLanguage(getSupportedLanguage());
  }, [i18n])

  useEffect(()=>{
    axios_getCreateAcctBefore();
  },[])

  const onRoleChange = (newColor, hasChanged)=>{
    if(hasChanged){
      setValue("userAcct","");
      setValue("userPcode","");
      setValue("userPcodeSecond","");
      clearErrors();
    }
  }

  const doubleCheckPcodeSecond = ()=>{
    let rule = setValidForm("userPcode");
    let newRules = {
      ...rule,
      validate: (val) => {
            if (watch('userPcode') !== val) return t('validation.confirm_password')
          }
    }
    return newRules;
  }

  // F0010101Before
  //建立前查詢form 規則 區分 主子帳戶
  const axios_getCreateAcctBefore = ()=>{
    let array = []
    F0010101Before()
      .then((res)=>{
        //第一步驟 
      if(checkDpSuccess(res)){
          res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result)
          })
      }
        return F0010102Before()
      }).then((res)=>{
        // 第二步驟 F0010102Before
        if(checkDpSuccess(res)){
          res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result)
          })
          setFormRule(array);
      }
      })
    
}

const axios_getF0010103Before=(identity)=>{
  F0010103Before(identity)
          .then((res)=>{
              if(checkDpSuccess(res)){
                let array = []
                  res?.data?.RespBody?.constraints?.forEach((item) => {
                      const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                      array.push(result)
                  })
                  setFormRule((pre)=>{
                    return[...pre,...array]
                  });
              
              }
          })
}
  const setValidForm = useCallback((formId) => {
      if (formRule?.length > 0) {
          const tmp = formRule?.find((item) => {
              return Object.keys(item)[0] === formId
          });
          return tmp ? tmp[formId] : '';
      }
  }, [formRule]);


  const checkKeyDown = (e) => {
    // if (e.key === 'Enter') e.preventDefault();
    if (e.keyCode === 13) {
      e.stopPropagation();
    }
  };

  const inputCheckKeyDown = (e) => { //避免觸發 按enter 後 就觸發 onSubmit 事件冒泡 給input 使用 <FormInput enterClick事件 ; 一般input onKeyDown事件
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  const handleRegisterAcct = (data) => {
    checkLoading(loading);
    let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';
    let reqBody = {
      userAcct: data.userAcct,
      userPcode: data.userPcode,
      userPcodeSecond: data.userPcodeSecond,
      audience: loginClientId(themeColorSession)  //身分別
    }
    registerAcct(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleActiveIndex(1);
          handleSuccessMessage(dispatch, t('message.account_check') + ' ' + t('message.success'));
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      })

  }

  const handleTaxIdNum = (data) => {
    let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';

    registerTaxIdNum({ 
      taxIdNum: data.taxIdNum, 
      audience:loginClientId(themeColorSession) 
    })
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res.data.RespBody;
          handleSuccessMessage(dispatch, t('message.taxIdNum_check') + ' ' + t('message.success'));
            //清空第三步的資料
            setValue("companyLeader","");
            setValue("companyEmail","");
            setValue("industryCode","");
            setValue("userName","");
            // setValue("userPhone","");
            setValue("userEmail","");

            if(issuer==='GOOGLE'){
              let email = JSON?.parse(sessionStorage?.getItem("decode_token"))?.["email"];
              let name = JSON?.parse(sessionStorage?.getItem("decode_token"))?.["name"];
              setValue("userEmail",email);
              setValue("userName",name);
            }
            
            

          if (data?.companyName !== "" || data?.companyAddress !== "") {
            setIsExistCompany(true); //已存在的公司帳戶 按鈕變加入 否則直接切到第3步驟
            setValue("companyName",data?.companyName);
            setValue("companyAddress",data?.companyAddress);
            axios_getF0010103Before("slave");
          } else {
            handleActiveIndex(2); //切到第3步
            setValue("companyName",data?.companyName);
            setValue("companyAddress",data?.companyAddress);
            axios_getF0010103Before("master");
          }
        }
      })
  }

  const handleMainSubAcct = (reqBody,identity) => { //第3步
    registerMainSubAcct(reqBody,identity)
      .then((res) => {
        if (checkDpSuccess(res)) {
          setConfirmLoad(false);
          AlertService.ask({
            title: `WOO HOO`,
            text: t('registerSuccess'),  //res?.data.RespBody?.message,
            type: AlertType.info,
            showCancelButton: false,
            confirmButtonText: t('button.confirm'),
            preConfirm: () => { navigate('/login') }
          });
        }
      }).finally((fin)=>{
        setConfirmLoad(false);
      })
  }

  const handleStep2AddIn = () => { //已有公司帳號存在 加入 帶入公司名稱,地址 等API F0010102 完成後串入
    handleActiveIndex(2);
  }

  const handleActiveIndex = (step) => {
    switch (step) {
      case 0:
        setActiveIndex(step);
        reset();
        setPrivacy(false);
        setAgreeMarketing(false);
        break;
      case 1:
        setActiveIndex(step);
        setPrivacy(false);
        setAgreeMarketing(false);
        break
      case 2://最後一步確認資料
        setActiveIndex(step);
        break;
    }
  }

  const onSubmit = async (data) => {

    if (activeIndex === 0) {
      handleRegisterAcct(data);
    } else if (activeIndex === 1) {
      handleTaxIdNum(data);
    } else if (activeIndex === 2) { //註冊主子帳戶
      setConfirmLoad(true);
      let reqBody = {
        taxIdNum: data.taxIdNum,
        companyName: data.companyName,
        companyAddress: data.companyAddress,
        companyLeader: data.companyLeader,
        companyEmail: data.companyEmail,
        userName: data.userName,
        // userPhone: data.userPhone,
        userEmail: data.userEmail,
        userAcct: data.userAcct,
        userPcode: data.userPcode,
        issuer:issuer===undefined?"JDBC":issuer,
        industryCode:data.industryCode,
        locale:data.locale, //use language add 2025/04/22
        country:data.country,
        agreeMarketing: agreeMarketing ? 'Y' : 'N'
      }
      if(issuer==='GOOGLE'){ //Google 登入 以下欄位不需帶入
        reqBody.idToken = sessionStorage?.getItem("id_token");
        // reqBody.userName = null; //userName 由使用者自己輸入
        reqBody.userEmail = null;
        reqBody.userAcct = null;
        reqBody.userPcode = null;
      }

      let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';
      reqBody.audience = loginClientId(themeColorSession);
      let identity = isExistCompany?'slave':'master'
      handleMainSubAcct(reqBody,identity);
    }

  }

    const [pdfUrl, setPdfUrl] = useState("");
    // const axios_downloadPdf = (linkTarget) => {
    //     initDataProp({ reqType: linkTarget })
    //         .then((res) => {
    //             if (checkDpSuccess(res)) {
    //                 let resData = res?.data?.RespBody;
    //                 console.log(resData);
    //                 setPdfUrl(resData.privacyBase64)
    //             }
    //         })

    // }
    useEffect(() => {
       if (activeIndex === 2 && !hasLoad) {
        // axios_downloadPdf('privacyBase64')
            initDataProp({ reqType: 'privacyBase64' })
            .then((res) => {
                if (checkDpSuccess(res)) {
                    let resData = res?.data?.RespBody;
                    // console.log(resData.privacyBase64);
                    setPdfUrl(resData.privacyBase64)
                    setHasLoad(true);
                }
            })
    }}, [activeIndex])
    const [PDFDialog, setPDFDialog] = useState(false);
    const [scrollToBottom, setScrollToBottom] = useState(false);
    const [privacy, setPrivacy] = useState(false);
    const [agreeMarketing, setAgreeMarketing] = useState(false);
    
    useEffect(() => {
    const handleMessage = (event) => {
      if (event.data === "scrollEnd") {
        setScrollToBottom(true);
        console.log("PDF 滾到底了！");
        // 你可以改成任何你要的邏輯
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <LoginCommonOutline mainBgPos="main-right" pageTitle={t("register_sys")} isMember={true}>
      <CompanyRoleSelector disabled={activeIndex===1 || activeIndex === 2 } onRoleChange={onRoleChange} />
      <Steps model={["", "", ""]} activeIndex={activeIndex} readOnly={true} className="register-steps" />

      <form className='grid' onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
        {/* step1 */}
        {
          activeIndex === 0 && (
            <>
              <div className='col-12'>
                <FormInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="userAcct"
                  labelText={t("account")}
                  type="text"
                  placeholder={t("account")}
                  rules={setValidForm("userAcct")}
                  enterClick={inputCheckKeyDown}
                />
              </div>
              <div className='col-12'>
                <FormInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="userPcode"
                  labelText={t('password')}
                  type="password"
                  placeholder={t('password')}
                  rules={setValidForm("userPcode")}
                  enterClick={inputCheckKeyDown}
                />
              </div>
              <div className="col-12">
                <FormInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="userPcodeSecond"
                  labelText={t('cfm_password')}
                  type="password"
                  placeholder={t('cfm_password')}
                  rules={doubleCheckPcodeSecond()}
                  enterClick={checkKeyDown}
                />
              </div>
              <div className='col-12 gap-2 flex-all-center'>
                <Button type="submit" className='w-100' label={t("button.next_step")} />
              </div>
              
            </>
          )
        }
        
        {/* step2 公司統一編號 */}
        {
          activeIndex === 1 && (
            <>
              <div className='col-12'>
                <FormInput
                  disabled={isExistCompany}
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="taxIdNum"
                  labelText={t("company_num")}
                  type="text"
                  rules={setValidForm("taxIdNum")}
                  placeholder={t("company_num")}
                  enterClick={inputCheckKeyDown}
                  tipSmall={t('taxIdNumHint')}
                />
              </div>
              <div className="col-12">
                {
                  isExistCompany && (
                    <label>{t('exist_account')}</label>
                  )
                }
              </div>
              <div className="col-12 gap-2 flex-all-center">
                <Button size='small'
                  disabled={issuer==='GOOGLE'}
                  onClick={() => {
                    handleActiveIndex(0);
                    setIsExistCompany(false); //返回上一步 取消已存在公司帳戶
                  }}
                  className='w-100'
                  label={t("button.pre_step")}
                  outlined
                />

                {
                  isExistCompany ? (
                    <Button onClick={() => { handleStep2AddIn(); }} type="button" size='small' className='w-100' label={t("button.add_in")} rounded />
                  ) : (
                    <Button
                      type="submit"
                      size='small'
                      className='w-100'
                      label={t("button.next_step")}
                    />
                  )
                }
              </div>
            </>
          )
        }
        {/* step3 填寫公司資料 */}
        {
          activeIndex === 2 && (
            <>
              <RegisterStep3
                setValue={setValue}
                control={control}
                isExistCompany={isExistCompany}
                register={register}
                errors={errors}
                inputCheckKeyDown={inputCheckKeyDown}
                setValidForm={setValidForm}
              />
              {/* 隱私權條款同意區域 */}
              <div className="col-12">
                <div style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer'}} onClick={()=>{setPDFDialog(true)}}>
                  <div style={{
                    width: '16px',
                    height: '16px',
                    border: '1px solid #ccc',
                    borderRadius: '2px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: privacy ? '#4CAF50' : 'transparent'
                  }}>
                    {privacy && (
                      <span style={{color: 'white', fontSize: '12px', fontWeight: 'bold'}}>✓</span>
                    )}
                  </div>
                  <span style={{fontSize: '14px'}}>
                    {privacy ? t('agree_privacy_policy') : t('view_privacy')}
                  </span>
                </div>
              </div>
              {/* 共同行銷同意區域 */}
              <div className="col-12">
                <Tooltip target=".marketing-info-icon" position="top" style={{ maxWidth: '320px' }} />
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                  <div
                    style={{
                      width: '16px',
                      height: '16px',
                      border: '1px solid #ccc',
                      borderRadius: '2px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: agreeMarketing ? '#4CAF50' : 'transparent',
                      cursor: 'pointer'
                    }}
                    onClick={() => setAgreeMarketing(!agreeMarketing)}
                  >
                    {agreeMarketing && (
                      <span style={{color: 'white', fontSize: '12px', fontWeight: 'bold'}}>✓</span>
                    )}
                  </div>
                  <span
                    style={{fontSize: '14px', cursor: 'pointer'}}
                    onClick={() => setAgreeMarketing(!agreeMarketing)}
                  >
                    {t('agree_marketing')}
                  </span>
                  <i
                    className="pi pi-info-circle marketing-info-icon"
                    data-pr-tooltip={t('agree_marketing_detail')}
                    style={{fontSize: '14px', cursor: 'pointer', color: '#6c757d'}}
                  />
                </div>
              </div>
              <div className="col-12 gap-2 flex-all-center">
                <Button size='small'
                  onClick={() => {
                    handleActiveIndex(1);
                    setIsExistCompany(false); //返回上一步 取消已存在公司帳戶
                  }}
                  className='w-100'
                  label={t("button.pre_step")}
                  outlined
                />
                <Button disabled={confirmLoad || !isValid || !privacy} loading={confirmLoad} type="submit" size='small' className='w-100' label={t("button.send")} />
              </div>
            </>
          )
        }
        <div className='field'>
          <a onClick={() => { navigate('/login');handleSessionClear(); }} className="mobile-link">{t('click_log_in')}</a>
        </div>
      </form>
      {/* 同意隱私條款 Dialog */}
      <PrimeDialog
                visible={PDFDialog}
                size="lg"
                onClose={() => { setPDFDialog(false); }}
                title={t('privacy_policy')}
                contentStyle={{padding:'0'}}
                confirmLabel="button.agree"
                disabledConfirm={!scrollToBottom}
                onConfirm={()=>{setPrivacy(true);setAgreeMarketing(true);setPDFDialog(false)}}
                bodyTemplate={
                  <PDFViewer url={pdfUrl} height='600px' />
                 
                }
            />
    </LoginCommonOutline>
  )
}
export default Register;
